import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { DoorOpen } from "lucide-react";
import { api } from "@/lib/apiClient";

export const PendingRoomsBanner = () => {
  const [n, setN] = useState(0);
  useEffect(() => { api.get("/room-bookings/pending-count").then((r) => setN(r.data.pending || 0)).catch(() => {}); }, []);
  if (!n) return null;
  return (
    <Link to="/salas" className="block kw-card p-4 border-l-4 !border-l-[#EAB308] hover:bg-[#111] transition-colors"
      data-testid="pending-rooms-banner">
      <div className="flex items-center gap-3">
        <DoorOpen className="w-5 h-5 text-[#EAB308] shrink-0" />
        <div>
          <div className="font-bold text-sm">{n === 1 ? "1 pedido de sala à espera de aprovação" : `${n} pedidos de sala à espera de aprovação`}</div>
          <div className="text-[11px] text-[#A3A3A3]">Carrega para aprovar ou recusar em Marcação de Salas.</div>
        </div>
      </div>
    </Link>
  );
};
